import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import ImageFadeIn from "react-image-fade-in";

function StackCard({
  title,
  subtitle,
  style,
  width,
  height,
  imageRef,
  onClick,
}) {
  const storage = useSelector((state) => state.storage);

  const defaultStyle = { width, height };
  const cardStyle = { ...style, ...defaultStyle };

  return (
    <div className="stack-card" style={cardStyle} onClick={onClick}>
      {storage && storage[imageRef] ? (
        <ImageFadeIn
          src={storage[imageRef]}
          width={width}
          height={height}
        />
      ) : (
        <div>
          <Skeleton height={height} width={width} />
        </div>
      )}
      <div className="shade" />
      <div className="stack-card-text">
        <div className="stack-card-title">{title}</div>
        <div className="stack-card-subtitle">{subtitle}</div>
      </div>
    </div>
  );
}

StackCard.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  imageRef: PropTypes.string,
};

export default StackCard;
